module.exports = __webpack_public_path__ + "static/media/covid-19_VietNam_June_2021.4258c59b.pdf";